import Vue from "vue";
window.gdprEventBus = new Vue();
export default window.gdprEventBus;
